export const childrenInfoAdapter = (listOfChildren) => {
  return listOfChildren.map(({ child, parent_can_edit } = {}) => {
    return {
      id: child.id,
      childIsActive: child.account_access,
      name: child.name,
      lastName: child.last_name,
      themeSelection: child.themeSelection,
      avatar: child.avatar ?? require(`@/assets/avatar.png`),
      points: child.points,
      level: child.level,
      coins: child.coins,
      parentCanEdit: parent_can_edit,
    };
  });
};
